<div (click)="categoryClicked(cat)" [ngClass]="isActive ? 'active' : 'inactive'">
  <span>{{cat}}</span>
</div>
